import { Injectable } from '@angular/core';
import {ApiService} from "../../../../services/api/api.service";
import {UserInfoService} from "../../../../services/user-info.service";
import {SortTableService} from "../../../../services/sort-table.service";
import {Observable} from "rxjs";
import {PaymentListModelsDto} from "../../../terminal-list/models/terminal.models";
import {CreateRegisterRequestDto} from "../models/register.models";

@Injectable({
  providedIn: 'root'
})
export class RegisterFormDataService {

  constructor(
    private apiService: ApiService,
  ) {}

  uploadRequest(data: CreateRegisterRequestDto): Observable<void> {
    const url = `/requests`
    return this.apiService.httpPost<void>(url, data)
  }
}
